export default __webpack_public_path__ + "static/media/countries.52535442.PNG";